import * as React from "react";
import { ErrorInfo } from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { NotificationTypeEnum } from "common/enums/NotificationTypeEnum";
import NotificationModal from "main/Notification/NotificationModal";
import * as ClientLogApi from "api/client-log.api";

interface State {
  hasError: boolean;
  error: string;
}

interface Props extends WithTranslation {}

class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: "" };
  }

  static getDerivedStateFromError(error: string) {
    return { hasError: true, error: error.toString() };
  }

  async componentDidCatch(error: Error, info: ErrorInfo) {
    await ClientLogApi.sendError(error.message, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <NotificationModal
          show
          setShow={() => this.setState({ hasError: false, error: "" })}
          notificationType={NotificationTypeEnum.ERROR}
        />
      );
    }

    return this.props.children;
  }
}

export default withTranslation()(ErrorBoundary);
